module.exports = __webpack_public_path__ + "static/img/cpfw-ptjg.f02c126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-ptjg.png
// module id = zPdI
// module chunks = 0